import client from "./client";

interface Params {
  rating: number;
  sessionId: string;
  clientId: string;
}

export const submitFeedback = ({ rating, sessionId, clientId }: Params) =>
  client.post(
    `/client/${clientId}/session/${sessionId}/feedback`,
    { rating },
    {
      headers: { session_id: sessionId },
    }
  );
